/* eslint-disable */
// @ts-nocheck
import {action, clientType, isAPP, isPc, isWechat, tgaEvent} from '@/appApi/index';
import { appver } from "@/common/script/unit";
import { isWechat } from '@/appApi/index';


import store from '../../store/index';
import cookies from "js-cookie";

export function setPage() {

    let platChannel = 'APP';

    if (!isAPP()) {
        platChannel = '微信';
        if(!isWechat()) {
            platChannel = '浏览器';
        }
    }

    let userId = '0';
    if (store.state.userInfo && (store.state.userInfo as any).userid) {
        userId = String((store.state.userInfo as any).userid);
    }
    if (window['g_tga']) {
        const deviceid = cookies.get('deviceid');
        if (deviceid) {
          window['g_tga'].identify(deviceid)
        }
        window.g_tga.login(userId);
        window.g_tga.setPageProperty({
            // "#ip": g_client_ip,
            "appos": appOs(),
            "appver": appver(),
            "platform": platform(),
            "plat_channel": platChannel
        });
    }
}

// 页面加载
export function viewEnter(tgaObj: any) {

    if (
      (isAPP() && clientType() !== 'harmonyNext')
      || (isAPP() && clientType() === 'harmonyNext' && appver() >= 120301)
    ) {
        tgaEvent('nb_web_view_enter', tgaObj)
    } else {
        if (window['g_tga']) {
          if (isWechat()) {
            window.g_tga.track('wx_app_view_enter', tgaObj)
          } else {
            window.g_tga.track('nb_web_view_enter', tgaObj)
          }
        }
    }
}

// 点击事件
export function clickTracking(tgaObj: any) {

  if (
    (isAPP() && clientType() !== 'harmonyNext')
    || (isAPP() && clientType() === 'harmonyNext' && appver() >= 120301)
  ) {
      tgaEvent('nb_web_click', tgaObj)
  } else {
    if (window['g_tga']) {
      if (isWechat()) {
        window.g_tga.track('wx_app_click', tgaObj)
      } else {
        window.g_tga.track('nb_web_click', tgaObj)
      }
    }
  }
}

export function appBannerBrowse(tgaObj: any) {
  if (
    (isAPP() && clientType() !== 'harmonyNext')
    || (isAPP() && clientType() === 'harmonyNext' && appver() >= 120301)
  ) {
      tgaEvent('app_banner_browse', tgaObj)
  } else {
    if (window['g_tga']) {
      window.g_tga.track('app_banner_browse', tgaObj);
    }
  }
}

export function nbWebAdBrowse(tgaObj: any) {
  if (
    (isAPP() && clientType() !== 'harmonyNext')
    || (isAPP() && clientType() === 'harmonyNext' && appver() >= 120301)
  ) {
      tgaEvent('nb_web_ad_browse', tgaObj)
  } else {
    if (window['g_tga']) {
      if (isWechat()) {
        window.g_tga.track('wx_app_ad_browse', tgaObj)
      } else {
        window.g_tga.track('nb_web_ad_browse', tgaObj);
      }
    }
  }
}


function appOs() {
    let appType = '';
    if (isPc()) {
        appType = 'pc';
        return appType;
    }
    appType = clientType();
    return appType;
}

function platform() {
    const ua = navigator.userAgent;
    if (isPc()) {
        return 'pc';
    }
    if (ua.match(/mqqbrowers/i)) {
        return 'qq';
    } else if (ua.match(/ipad/i)) {
        return 'ipad';
    } else if (ua.match(/iphone/i)) {
        return 'iphone';
    } else if (ua.match(/ipod/i)) {
        return 'ipod';
    } else if (ua.match(/android/i)) {
        return 'android';
    } else if (ua.match(/harmony/i)) {
        return 'harmony';
    } else if (ua.match(/mqqbrowers/i)) {
        return 'qq';
    }
}
